<div id="lassoTool" class="lasso-tool" #lassoTool>
    <mc-sketch-tool-ng id="lassoSketchTool" #sketchTool></mc-sketch-tool-ng>
</div>